import { render, staticRenderFns } from "./ProdOrderSearch.vue?vue&type=template&id=b1463c2a&"
import script from "./ProdOrderSearch.vue?vue&type=script&lang=js&"
export * from "./ProdOrderSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports